export default {
    page_title: 'Widget List',
    create_new: 'Create a New Widget',
    new: 'New Widget',
    update: 'Edit Widget',
    price: 'Price',
    no_items: 'No results found',
    reduced_price: 'Discounted Price',
    published: 'Published',
    unpublished: 'Unpublished',
    errors: {
        image_required: 'Image is required for all rows',
        slug: 'ID is required for all rows',
        config_id_required: 'Config ID is required for all rows',
        product_required: 'Product is required for all rows',
    },
    form_actions: {
        select_type: 'Select Type',
        select_product: 'Select Product',
        select_image: 'Select Image',
        select_id: 'Add an ID',
        select_config_id: 'Add Config ID',
        select_id_info: 'Required for easier identification by other sources',
        select_provider: 'Select Provider',
        add_row: 'Add Product',
        save: 'Save',
        reorder_drag: 'Drag to reorder',
        drag: 'Drag',
        remove: 'Remove',
        change_product: 'Change Product',
        copy: 'Copy'
    },
    reason: {
        inactive_product: 'Product was deactivated by the provider',
        invalid_id: 'Product was deleted from the database',
    },
    table: {
        header: {
            data: 'Data',
            id: 'ID',
            type: 'Type',
            published: 'Published',
            available_start: 'Available Start',
            available_end: 'Available End',
            created_at: 'Created At',
            updated_at: 'Updated At',
            status: 'Status',
        }
    },
    modal: {
        select_product_title: 'Selec Product',
        provider: 'Provider',
        select_provider_first: 'Select Provider',
        name: 'Name',
        brand: 'Brand',
        price: 'Price',
        action: 'Action',
    },
    carousel: {
        common: {
            active: 'Active',
            inactive: 'Inactive',
            product: 'Product',
            products: 'Products',
            offer: 'Offer',
            offers: 'Offers',
            benefits: 'Benefits',
            transparent: 'Transparent',
            languages: {
                ro: 'RO',
                en: 'EN',
            },
            positions: {
                topLeft: 'Top left',
                topRight: 'Top right',
                bottomLeft: 'Bottom left',
                bottomRight: 'Bottom right',
            }
        },
        generalSettings: {
            title: 'General settings',
            sections: {
                statusIdentity: 'Status & identity',
                availability: 'Availability',
                widgetBehavior: 'Widget behavior',
            },
            fields: {
                status: 'Status',
                widgetActive: 'Widget active',
                priority: 'Priority',
                productType: 'Product type',
                widgetId: 'Widget ID',
                tracking: 'Tracking',
                availableStart: 'Available start date & time',
                availableEnd: 'Available end date & time',
                cardRatio: 'Card ratio',
                autoScroll: 'Auto scroll',
                displayPageIndicator: 'Display page indicator',
            },
            placeholders: {
                widgetId: 'ex: carrefour_100_ron',
                tracking: 'tracking',
            },
            help: {
                productType: 'You cannot combine benefits with offers in the same widget.',
                widgetId: 'Required field. It is automatically transformed into a slug using underscore.',
                cardRatio: 'The value represents the width:height ratio. Example: 2 = 2:1',
            }
        },
        generalTab: {
            title: 'Shared background image',
            description: 'If you upload an image here, it will be used as a shared background for all products in the widget where the product does not have its own configured image.',
            fields: {
                uploadImage: 'Upload image',
            },
            help: {
                acceptedFormat: 'Accepted format: image. Maximum size: 1 MB.',
            },
            actions: {
                removeImage: 'Remove image',
            },
            errors: {
                invalidImage: 'The selected file must be an image.',
                imageTooLarge: 'The image must not exceed 1 MB.',
            },
            alt: {
                backgroundPreview: 'Background image preview',
            }
        },
        textSettings: {
            title: 'Text content',
            sections: {
                title: 'Title',
                subtitle: 'Subtitle',
                footer: 'Footer',
            },
            errors: {
                maxLength: 'You have reached the maximum limit of 100 characters.',
            }
        },
        tabs: {
            general: 'General',
            text: 'Text',
            products: 'Products',
            offers: 'Offers',
        },
        productsTab: {
            description: 'Each {item} represents one slide in the carousel. Inside it you can configure the image, card style, and badges displayed over the image.',
            warningInactive: 'The widget is inactive. Activate the widget to edit {items}.',
            actions: {
                addProduct: 'Add product',
                addOffer: 'Add offer',
            },
            defaults: {
                newProduct: 'New product',
                newOffer: 'New offer',
            }
        },
        productsList: {
            empty: 'You have not added any {item} yet.',
            unnamedItem: 'Unnamed {item}',
            reason: 'Reason: {reason}',
            actions: {
                replace: 'Replace {item}',
                duplicate: 'Duplicate',
                delete: 'Delete',
            },
            alt: {
                preview: 'Preview',
            }
        },
        productEditor: {
            title: 'Slide configuration',
            unnamedProduct: 'Unnamed product',
            inactiveWarning: 'The product is inactive. Editing is blocked until the product becomes active again.',
            emptyBadges: 'There are no badges for this position.',
            badgeNumber: 'Badge #{index}',
            sections: {
                productStatus: 'Product status',
                productImage: 'Product image',
                voucherLink: 'Voucher link',
                badges: 'Badges',
            },
            fields: {
                productActive: 'Product active',
                reason: 'Reason',
                uploadImage: 'Upload image',
                useAutomaticUrl: 'Use automatic URL',
                voucherUrl: 'Voucher URL',
                contentMode: 'Content mode',
                insertVariables: 'Insert variables',
                titleRo: 'Title RO',
                titleEn: 'Title EN',
                titleColor: 'Title color',
                transparentBackground: 'Transparent background',
                backgroundColor: 'Background color',
                badgeImage: 'Badge image',
                cornerRadius: 'Corner radius',
                useDShape: 'Use D shape',
                paddingTop: 'Padding top',
                paddingLeft: 'Padding left',
                paddingRight: 'Padding right',
                paddingBottom: 'Padding bottom',
                marginTop: 'Margin top',
                marginLeft: 'Margin left',
                marginRight: 'Margin right',
                marginBottom: 'Margin bottom',
            },
            placeholders: {
                reason: 'Unavailable reason',
                voucherUrl: 'Enter the voucher URL',
                hexColor: '#FFFFFF',
            },
            help: {
                productImage: 'The product image is displayed only if there is no global image.',
                voucherUrl: 'When the automatic option is enabled, the URL is generated based on product_id.',
                uncheckTransparent: 'Uncheck “Transparent” to set a background color.',
            },
            actions: {
                removeImage: 'Remove image',
                addBadge: 'Add badge',
            },
            contentModes: {
                custom: 'Custom',
                productVariable: 'Product variable',
                mixed: 'Mixed',
            },
            productVariables: {
                name: 'Name',
                brandName: 'Brand name',
                value: 'Value',
                productName: 'Product name',
                price: 'Price',
                reducedPrice: 'Reduced price',
                reducedUserDiscount: 'Reduced user discount',
                discount: 'Discount',
            },
            errors: {
                invalidImage: 'The selected file must be an image.',
                imageTooLarge: 'The image must not exceed 1 MB.',
            },
            alt: {
                productImagePreview: 'Product image preview',
                badgePreview: 'Badge preview',
            }
        },
        preview: {
            title: 'Preview',
            unavailableProduct: 'Unavailable product',
            noBackground: 'No background',
            empty: 'Add products to see the full preview.',
            previous: 'Previous',
            next: 'Next',
            alt: {
                badge: 'badge',
            }
        }
    }
}